// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { PatchPlayerData, PatchPlayerDataT } from '../tbs/patch-player-data.js';


export class PatchPlayerAction implements flatbuffers.IUnpackableObject<PatchPlayerActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PatchPlayerAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPatchPlayerAction(bb:flatbuffers.ByteBuffer, obj?:PatchPlayerAction):PatchPlayerAction {
  return (obj || new PatchPlayerAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPatchPlayerAction(bb:flatbuffers.ByteBuffer, obj?:PatchPlayerAction):PatchPlayerAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PatchPlayerAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapPatchPlayer;
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

data(obj?:PatchPlayerData):PatchPlayerData|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new PatchPlayerData()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startPatchPlayerAction(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapPatchPlayer);
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt16(1, playerId, 0);
}

static addData(builder:flatbuffers.Builder, dataOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, dataOffset, 0);
}

static endPatchPlayerAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): PatchPlayerActionT {
  return new PatchPlayerActionT(
    this.type(),
    this.playerId(),
    (this.data() !== null ? this.data()!.unpack() : null)
  );
}


unpackTo(_o: PatchPlayerActionT): void {
  _o.type = this.type();
  _o.playerId = this.playerId();
  _o.data = (this.data() !== null ? this.data()!.unpack() : null);
}
}

export class PatchPlayerActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapPatchPlayer,
  public playerId: number = 0,
  public data: PatchPlayerDataT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const data = (this.data !== null ? this.data!.pack(builder) : 0);

  PatchPlayerAction.startPatchPlayerAction(builder);
  PatchPlayerAction.addType(builder, this.type);
  PatchPlayerAction.addPlayerId(builder, this.playerId);
  PatchPlayerAction.addData(builder, data);

  return PatchPlayerAction.endPatchPlayerAction(builder);
}
}
